import { useEffect, useState, useCallback, useMemo, useRef, lazy, Suspense } from "react";
import "./scss/WheelOfPrizes.scss";
import WheelOfPrizesMakisWon from "./WheelOfPrizesMakisWon";
import WheelOfPrizesMakisLost from "./WheelOfPrizesMakisLost";
import SubmitButton from "./SubmitButton";
import novibetImage from './novibet.png';
import MakisBar2 from "../common/MakisBar2";

const PhaserWheel = lazy(() => import('../common/PhaserWheel'));


function WheelOfPrizes({ data, value, sending, elementErrors, onChange, onSubmit, goToNextPage, result, primaryTextColor, button }) {
	// console.log('~WheelOfPrizes', data.id, value, elementErrors)
	const pathname = window.location.pathname;
	const campaignId = pathname.split('/')[1];
	const [screen, setScreen] = useState(null);
	const [spinning, setSpinning] = useState(false);
	const [loading, setLoading] = useState(false);
	const [mappedData, setMappedData] = useState(null);
	const [sliceIndex, setSliceIndex] = useState(null);
	const [spinResult, setSpinResult] = useState(null);
	const [isWheelReady, setIsWheelReady] = useState(false);

	const isNovibet = useMemo(() => {
		return ['pxYhIDJ3nAZ0ppKCZLce', 'CkYDNrwjZPJqs2DjCzNP', 'Focaphg4gEUycfwgvoXQ'].includes(campaignId);
	}, [campaignId])
	const shouldApplyWheelStyling = () => {
		return data.image || isNovibet
	}

	const defaultColors = [
		"#0466c8",
		"#023e7d",
		"#001845",
		"#33415c",
		"#5bba6f",
		"#137547",
		"#fbb13c",
		"#ffd97d",
		"#a4133c",
		"#ff758f",
		"#3a0ca3",
		"#3f37c9",
		"#4895ef"
	];

	const textColors = useMemo(() => {
		return data?.slices.reduce((acc, slice) => [...acc, ...[slice.textColor || '#fff']], [])
	}, [data]);

	const spin = useCallback(() => {
		setLoading(true);
		onSubmit(null, false);
	}, [onSubmit])

	const setData = useCallback((data) => {
		console.log("spinResult", spinResult)
		setSpinning(false);
		if (spinResult['won']) {
			setScreen('won')
		} else {
			setScreen('lost')
		}
	}, [spinResult])

	// useEffect( () => {
	// 	if(spinResult){
	// 		setData()
	// 	}
	// }, [spinResult, screen])

	const hasSpin = useRef(false);
	useEffect( () => {
		if(mappedData && !hasSpin.current){
			hasSpin.current = true
			setTimeout(() => spin(), 200)
		}
	}, [mappedData, spinResult])

	// useEffect( () => {
	// 	setTimeout(() => spin(), 500)
	// }, [])

	const borderImageStyling = useMemo(() => {
		if (!shouldApplyWheelStyling) return {};

		return {
			// backgroundImage: `url(${data.borderImage || '/images/common/border.png'})`,
			backgroundSize: `${data.borderImageSize || 130}%`,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '50% center'
		}
	}, [data])

	useEffect(() => {
		const d = data?.slices.map((slice, idx) => {
			let o = {
				option: slice.text,
				style: {
					backgroundColor: slice.color || defaultColors[idx],
					textShadowColor: slice.textShadowColor
				},
			}
			if (slice.image && slice.image !== '/images/common/placeholder.png') {
				o['image'] = { uri: slice.image, sizeMultiplier: slice.imageSizeMultiplier, offsetY: slice.imageOffsetY };
			}
			return o
		})
		setMappedData(d);
		onChange(data.id, true);
	}, [data])

	useEffect(() => {
		if (!result ) return;
		console.log("result", result)
		Object.entries(result['responses']).forEach(([key, value]) => {
			if(!value['elements']){
				return;
			}
			Object.entries(value['elements']).forEach(([elKey, elValue]) => {
				if (!elValue['spinResult']) return;
				console.log("elValue['spinResult']", elValue['spinResult'])
				setSpinResult(elValue['spinResult']);
				setSliceIndex(parseInt(elValue['spinResult']['sliceIndex']));
				setTimeout(() => {
					setLoading(false);
					setSpinning(true);
				}, 150);
			})
		})
	}, [result])
	const spinDuration = Number.isFinite(data.spinDuration) ? data.spinDuration : 6;
	return (
		<div style={{ marginTop: data?.marginTop }} className="wheel_ofprizes">
			{screen === null &&
				<>
					{mappedData &&
						<Suspense>
							<>
								<div className="text--center">
									{spinResult && spinResult['won'] &&
										<div>
											<MakisBar2 winSlice={mappedData[spinResult.sliceIndex]} prize={spinResult?.prize} onStopSpinning={setData} />
											{/* <h4 style={{ fontSize: '2em' }}>{spinResult?.prize?.text}</h4>
											<div>{spinResult?.prize?.description}</div> */}
										</div>
									}
								</div>
								<div>
									{/* <SubmitButton
										text={data.buttonText || "Spin now"}
										size={button?.submitSize}
										onSubmit={spin}
										buttonStyle={{ borderRadius: button?.borderRadius, background: data.buttonColor, color: data.textColor }}
									/> */}
								</div>
							</>
						</Suspense>
					}
				</>
			}
			{screen === 'won' && <WheelOfPrizesMakisWon next={goToNextPage} styling={data} data={spinResult} button={button} />}
			{spinResult && !spinResult['won'] &&
				<WheelOfPrizesMakisLost next={goToNextPage} styling={data} data={data} primaryTextColor={primaryTextColor} button={button} />
			}
		</div>
	);
};
export default WheelOfPrizes;
